export default __webpack_public_path__ + "static/media/W_C_True.8245051d.jpg";